import '@ionic/core';
import { Component, Element, h, Prop } from '@stencil/core';

@Component({
  tag: 'social-view',
  styleUrl: 'social-view.css',
  shadow: true
})
export class OpportunityCard {
    @Element() el: HTMLElement;

    @Prop({ attribute: 'cohort-id' }) opportunityCohortId: number = -106;
    @Prop({ attribute: 'partner-id' }) opportunityPartnerId: number = -116;
    @Prop({ attribute: 'opportunity-id' }) opportunityId: number = -126;
    @Prop({ attribute: 'opportunity-type' }) opportunityType: string = 'case';

    copyShareURL = async () => {
        // Select the element with the ID SocialShareLink
        const copyText = this.el.shadowRoot.querySelector("#SocialShareLink") as HTMLTextAreaElement;

        // Use the Clipboard API to write text
        try {
            await navigator.clipboard.writeText(copyText.value);
            alert("Share URL Copied to clipboard successfully!");
        } catch (err) {
            console.error("Failed to copy: ", err);
        }
    };

    render() {
        switch(this.opportunityType) {
            case 'case':
                return (
                    <div id="SocialViewStage">
                        <div id="SocialShareInstructions">
                            If you know someone that might be interested in helping this person, please copy and paste the link
                            below into an email, tweet, or SMS message.
                        </div>
                        <ion-textarea onClick={this.copyShareURL} id="SocialShareLink" fill='outline' value={`https://probono.savvysuit.com/cohort/${this.opportunityCohortId}/partners/${this.opportunityPartnerId}/cases/${this.opportunityId}/`} readonly></ion-textarea>
                    </div>
                );

            case 'clinic':
                return(
                    <div id="SocialViewStage">
                        <div id="SocialShareInstructions">
                            If you know someone that might be interested in helping, please copy and paste the link
                            below into an email, tweet, or SMS message.
                        </div>
                        <ion-textarea onClick={this.copyShareURL} id="SocialShareLink" fill='outline' value={`https://probono.savvysuit.com/cohort/${this.opportunityCohortId}/partners/${this.opportunityPartnerId}/clinics/${this.opportunityId}/`} readonly></ion-textarea>
                    </div>
                );

            default:
                return(
                    <div id="SocialViewStage">Unrecognized Opportunity Type</div>
                );
        }
    }
}
